import { type ReactNode, useState } from 'react'
import type { Clients } from '../utils/useCustomizationByURLParams'
import { LayoutContext } from './LayoutContext'

type Props = {
  children: ReactNode
}

const LayoutProvider = ({ children }: Props) => {
  const [client, setClient] = useState<Clients | null>(isPurePWA() ? 'app' : null)

  return (
    <LayoutContext.Provider
      value={{
        client,
        setClient,
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}

// https://stackoverflow.com/a/52695341/6544122
export const isPurePWA = () =>
  Boolean(
    window.matchMedia('(display-mode: standalone)').matches ||
      // @ts-expect-error Standalone
      window.navigator['standalone'] ||
      document.referrer.includes('android-app://') ||
      document.referrer.includes('capacitor://') ||
      window.navigator.userAgent.includes('FaceUpApp')
  )

export default LayoutProvider
